module.exports = __webpack_public_path__ + "img/license_allow.0c6866b5.svg";